import { Chip } from '@mui/material'
import { EProcessingStatus, getStatusColor } from '@src/types/automationDocument'
import { useTranslation } from 'react-i18next'

const shimmerSx = {
  position: 'relative',
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
    animation: 'shimmer 2s infinite',
  },
  '@keyframes shimmer': {
    '0%': { left: '-100%' },
    '100%': { left: '100%' },
  },
} as const

const PROCESSING_STATUSES = new Set([
  EProcessingStatus.Pending,
  EProcessingStatus.PendingBatch,
  EProcessingStatus.Stored,
  EProcessingStatus.Processing,
  EProcessingStatus.Classified,
  EProcessingStatus.Extracted,
])

export const StatusChip = ({ status, shimmer = true }: { status: EProcessingStatus; shimmer?: boolean }) => {
  const { t } = useTranslation()

  return (
    <Chip
      label={t(`enum.processingStatus.${status}` as const)}
      color={getStatusColor(status)}
      disabled={status === EProcessingStatus.Finalized}
      variant="outlined"
      size="small"
      sx={shimmer && PROCESSING_STATUSES.has(status) ? shimmerSx : undefined}
    />
  )
}
